import React from 'react';
import { useApp } from '../../context/AppContext';

const PLAT_META = {
  instagram:{ label:'Instagram', icon:'📸', color:'#e1306c' },
  facebook: { label:'Facebook',  icon:'👥', color:'#1877f2' },
  blog:     { label:'Blog',      icon:'📝', color:'#2e7d32' },
};

const STATUS_COLOR = {
  draft:     '#9ca3af',
  scheduled: 'var(--sky-dk)',
  published: 'var(--leaf)',
};

export default function BlogPosts({ onNavigateCreate }) {
  const { conPosts, updateConPost, removeConPost } = useApp();
  const blogs = conPosts.filter(p => p.platform === 'blog');

  async function publish(id) {
    await updateConPost(id, { status:'published', published_at: new Date().toISOString() }).catch(console.error);
  }

  async function remove(id) {
    if (!confirm('Delete this blog post?')) return;
    await removeConPost(id).catch(console.error);
  }

  return (
    <div style={{ overflowY:'auto', padding:'20px 24px' }}>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16 }}>
        <div>
          <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:22, fontWeight:700 }}>Blog Posts</div>
          <div style={{ fontSize:11, color:'#9ca3af', marginTop:2 }}>Long-form · SEO-optimised · 600–900 words</div>
        </div>
        <button className="btn btn-sm" style={{ background:'var(--rose)', color:'#fff', border:'none' }}
          onClick={() => onNavigateCreate?.('blog')}>
          + New Blog Post
        </button>
      </div>

      <div className="info-box blue" style={{ marginBottom:16 }}>
        <span style={{ fontSize:14, flexShrink:0 }}>📝</span>
        <div><strong>Publishing:</strong> Generate a post in Create, click <strong>Copy</strong> and paste into your CMS. Mark as Published here to track it.</div>
      </div>

      {blogs.length === 0 ? (
        <div className="empty-state" style={{ background:'var(--white)', borderRadius:'var(--r)', border:'1.5px dashed var(--border)', padding:36 }}>
          <div style={{ fontSize:28, marginBottom:10 }}>📝</div>
          No blog posts yet.<br/>
          <span style={{ fontSize:11, opacity:.7 }}>Good topics: brewing guides, sustainability stories, hotel coffee culture, recipe roundups.</span>
        </div>
      ) : (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(300px,1fr))', gap:10 }}>
          {blogs.map(p => (
            <BlogCard key={p.id} post={p} onPublish={publish} onRemove={remove} />
          ))}
        </div>
      )}
    </div>
  );
}

function BlogCard({ post, onPublish, onRemove }) {
  const statusColor = STATUS_COLOR[post.status]||'#9ca3af';
  const wordCount   = (post.content||'').split(/\s+/).filter(Boolean).length;
  return (
    <div style={{ background:'var(--white)', borderRadius:'var(--r)', border:`1.5px solid ${post.status==='published'?'var(--sage)':'var(--border)'}`, overflow:'hidden', boxShadow:'var(--sh)' }}>
      <div style={{ padding:'10px 13px', background:'var(--fog)', borderBottom:'1px solid var(--border)', display:'flex', alignItems:'center', gap:8 }}>
        <span style={{ fontSize:16 }}>📝</span>
        <div style={{ flex:1, minWidth:0 }}>
          <div style={{ fontSize:12, fontWeight:700, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{post.title||'Blog Post'}</div>
          <div style={{ fontSize:10, color:'#9ca3af' }}>{wordCount} words · {post.created_at?.slice(0,10)||''}</div>
        </div>
        <span style={{ fontSize:9, fontWeight:700, textTransform:'uppercase', color:statusColor }}>{post.status}</span>
      </div>
      <div style={{ padding:'10px 13px', fontSize:12, color:'#4b5563', lineHeight:1.6, maxHeight:120, overflow:'hidden', display:'-webkit-box', WebkitLineClamp:5, WebkitBoxOrient:'vertical' }}>
        {post.content||''}
      </div>
      {post.scheduled_date && <div style={{ padding:'3px 13px', fontSize:10, color:'var(--sky-dk)', fontWeight:600 }}>📅 Scheduled: {post.scheduled_date}</div>}
      {post.published_at   && <div style={{ padding:'3px 13px', fontSize:10, color:'var(--leaf)', fontWeight:600 }}>✅ Published: {post.published_at.slice(0,10)}</div>}
      <div style={{ padding:'8px 13px', borderTop:'1px solid var(--border)', display:'flex', gap:6, background:'var(--fog)' }}>
        <button className="btn btn-outline btn-xs" onClick={() => navigator.clipboard.writeText(post.content||'')}>📋 Copy</button>
        {post.status !== 'published' && <button className="btn btn-green btn-xs" onClick={() => onPublish(post.id)}>✓ Mark Published</button>}
        <button className="btn btn-ghost btn-xs" style={{ color:'var(--rose)', marginLeft:'auto' }} onClick={() => onRemove(post.id)}>🗑</button>
      </div>
    </div>
  );
}
